// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"56242715","450":"91164944","732":"5fc2aed6","884":"b1fae982","977":"ceb0cfb4"}[chunkId] + ".chunk.js";
};